import { PayloadAction } from '@reduxjs/toolkit';
import { DefaultFollowUpUpdateFormState, EActionState, IAppointmentCombinedState, IFollowUpUpdateFormState } from 'models';

export interface IState {
	activityId: string;
	followUpId: string;
	update: EActionState;
	open: boolean;
	followUps: IAppointmentCombinedState[];
	form: IFollowUpUpdateFormState;
	init: EActionState;
	opportunityId: string;
	onSuccess?: () => PayloadAction<any>;
}

export const initialState: IState = {
	activityId: '',
	followUpId: '',
	update: EActionState.COMPLETED,
	open: false,
	followUps: [],
	form: DefaultFollowUpUpdateFormState,
	init: EActionState.PENDING,
	opportunityId: '',
	onSuccess: undefined
};
